/**
 * Created by Ning Jiang on 2021-05-28.
 */

import {ReelStopPresentationController} from "../ReelStopPresentationController";
import {IReelStateEventData, ReelState} from "../../../core/reel/ReelState";
import {Oktoberfest} from "../../Oktoberfest";
import {ArrayHelper} from "@nolimitcity/slot-game/bin/utils/ArrayHelper";
import {OktoberfestSymbol} from "../../symbol/OktoberfestSymbol";
import {TimelineLite} from "gsap";
import {GameHelper} from "../../../core/utils/GameHelper";

export class WildLandingController extends ReelStopPresentationController {

    private _animations: TimelineLite[] = [];

    constructor() {
        super("WildLandingController");
    }

    public skip() {
        super.skip();
        this._animations.forEach(a => a.timeScale(2));
    }

    protected async onReelStopped(data: IReelStateEventData): Promise<any> {
        const promises: Promise<any>[] = [];
        const symbols: OktoberfestSymbol[] = [];
        const isStackedMode: boolean = Oktoberfest.model.parsedGameData.mode === "STACKED_PARTY_SPIN";
        if (Oktoberfest.model.parsedGameData.nearWinReels[3] && !isStackedMode) {
            Oktoberfest.model.reels[data.reelId].forEach((symName, symIndex) => {
                if (symIndex <= 2) {
                    const symbol2 = Oktoberfest.reels[data.reelId].getSymbol(symIndex);
                    const isRespin: boolean = Oktoberfest.model.parsedGameData.mode === "WILD_RESPIN";
                    const isFirstOverLayWild: boolean = Oktoberfest.model.parsedGameData.overlayWilds[2][0] !== null;
                    if (data.reelId === 4 ) {
                        if (!( isRespin && isFirstOverLayWild )) {
                            GameHelper.resetAllSymbols();
                        } else {
                            GameHelper.dimDownAllSymbols(symbol2,"W");
                        }
                    } else  {
                        GameHelper.dimDownAllSymbols(symbol2,"W");
                    }
                }
                if (symName.includes("W") && Oktoberfest.reels[data.reelId].isDataSymbolInValidArea(symIndex)) {
                    const symbol = Oktoberfest.reels[data.reelId].getSymbol(symIndex, true);
                    if (!symbols.includes(symbol) && symbol.symbolName.indexOf("*") > -1) {
                        Oktoberfest.dimOverLay.onDimStage();
                        symbols.push(symbol);
                        const tween: TimelineLite = new TimelineLite();
                        tween.add(symbol.playLanding(),0.001);
                        if (this.isSkip) {
                            tween.timeScale(2);
                        }
                        this._animations.push(tween);
                        promises.push(Promise.resolve(tween).then(res => {
                            ArrayHelper.removeFirstMatchElement(this._animations, tween);
                        }));
                    }

                }
            });

        }
        await Promise.all(promises);
        symbols.length = 0;
    }
}